var indexOf;

if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
} else {
    indexOf = function (o) {
        // I know
        var i;
        for (i = 0; i < this.length; ++i) {
            if (this[i] === o) {
                return i;
            }
        }
        return -1;
    };
}

export { indexOf as default };



//////////////////
// WEBPACK FOOTER
// ./~/moment/src/lib/utils/index-of.js
// module id = 81
// module chunks = 0